import { connect }                          from 'react-redux';
import { fetchDirections, resetDirections,
    showDirections }                        from './../actions/DirectionsAction';
import { setMapObject }                     from './../actions/MapAction';
import PlaceMapView                         from './../components/PlaceMapView';

const mapStateToProps = (state) => {
    return {
        hasGoogle : state.appHeader.google,
        theme     : state.assets.items.theme.body,
        directions: state.directions,
        geo       : state.geo,
        filter    : state.filter
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDirections: (origin, destination) => {
            dispatch(fetchDirections(origin, destination));
        },
        resetDirections: () => {
            dispatch(resetDirections);
        },
        showDirections: (place) => {
            dispatch(showDirections(place));
        },
        setMapObject: (map) => {
            dispatch(setMapObject(map));
        }
    }
};

const PlaceMapViewContainer = connect(mapStateToProps, mapDispatchToProps)(PlaceMapView);

export default PlaceMapViewContainer;



// WEBPACK FOOTER //
// ./src/containers/PlaceMapViewContainer.js